import { useCssVars as _useCssVars } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "rich-text-editor rounded-xl border border-slate-200 bg-white overflow-hidden"
};
const _hoisted_2 = {
  key: 0,
  class: "toolbar flex flex-wrap items-center gap-0.5 border-b border-slate-200 bg-slate-50 px-2 py-1.5"
};
const _hoisted_3 = ["value"];
const _hoisted_4 = ["value"];
const _hoisted_5 = ["value"];
const _hoisted_6 = {
  class: "relative"
};
const _hoisted_7 = {
  class: "toolbar-btn",
  title: "文字颜色"
};
const _hoisted_8 = ["value"];
const _hoisted_9 = {
  class: "relative"
};
const _hoisted_10 = {
  class: "toolbar-btn",
  title: "背景颜色"
};
const _hoisted_11 = ["value"];
const _hoisted_12 = ["disabled"];
const _hoisted_13 = ["disabled"];
const _hoisted_14 = {
  key: 2,
  class: "flex items-center justify-end gap-3 border-t border-slate-100 bg-slate-50/50 px-3 py-1 text-xs text-slate-400"
};
import { ref, watch, computed, onMounted, onBeforeUnmount } from 'vue';
import { useEditor, EditorContent } from '@tiptap/vue-3';
import { BubbleMenu } from '@tiptap/vue-3/menus';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import { TextStyle } from '@tiptap/extension-text-style';
import { Color } from '@tiptap/extension-color';
import Highlight from '@tiptap/extension-highlight';
import TextAlign from '@tiptap/extension-text-align';
import Subscript from '@tiptap/extension-subscript';
import Superscript from '@tiptap/extension-superscript';
import Link from '@tiptap/extension-link';
import Image from '@tiptap/extension-image';
import FontFamily from '@tiptap/extension-font-family';
import Placeholder from '@tiptap/extension-placeholder';
import { Table } from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import TaskList from '@tiptap/extension-task-list';
import TaskItem from '@tiptap/extension-task-item';
import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight';
import CharacterCount from '@tiptap/extension-character-count';
import Typography from '@tiptap/extension-typography';
import { common, createLowlight } from 'lowlight';
import { Extension, Node, mergeAttributes } from '@tiptap/core';
import { ElMessage } from 'element-plus';
import { uploadFile } from '@/api/file';
import { resolveUploadedFileUrl } from '@/utils/uploadUrl';
export default {
  __name: 'RichTextEditor',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入内容...'
    },
    minHeight: {
      type: String,
      default: '200px'
    },
    uploadModule: {
      type: String,
      default: 'editor'
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    _useCssVars(_ctx => ({
      "v2e21c027": __props.minHeight
    }));
    const lowlight = createLowlight(common);
    const props = __props;
    const emit = __emit;
    const imageInput = ref(null);
    const videoInput = ref(null);

    // 自定义 FontSize 扩展
    const FontSize = Extension.create({
      name: 'fontSize',
      addOptions() {
        return {
          types: ['textStyle']
        };
      },
      addGlobalAttributes() {
        return [{
          types: this.options.types,
          attributes: {
            fontSize: {
              default: null,
              parseHTML: el => el.style.fontSize?.replace(/['"]+/g, '') || null,
              renderHTML: attrs => {
                if (!attrs.fontSize) return {};
                return {
                  style: `font-size: ${attrs.fontSize}`
                };
              }
            }
          }
        }];
      },
      addCommands() {
        return {
          setFontSize: fontSize => ({
            chain
          }) => {
            return chain().setMark('textStyle', {
              fontSize
            }).run();
          },
          unsetFontSize: () => ({
            chain
          }) => {
            return chain().setMark('textStyle', {
              fontSize: null
            }).removeEmptyTextStyle().run();
          }
        };
      }
    });
    const Video = Node.create({
      name: 'video',
      group: 'block',
      atom: true,
      addOptions() {
        return {
          HTMLAttributes: {
            controls: 'controls'
          }
        };
      },
      addAttributes() {
        return {
          src: {
            default: null
          }
        };
      },
      parseHTML() {
        return [{
          tag: 'video[src]'
        }];
      },
      renderHTML({
        HTMLAttributes
      }) {
        return ['video', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
      },
      addCommands() {
        return {
          setVideo: attrs => ({
            commands
          }) => {
            return commands.insertContent({
              type: this.name,
              attrs
            });
          }
        };
      }
    });
    const editor = useEditor({
      content: '',
      extensions: [StarterKit.configure({
        heading: {
          levels: [1, 2, 3, 4, 5, 6]
        },
        codeBlock: false // 使用 CodeBlockLowlight 替代
      }), Underline, TextStyle, Color, Highlight.configure({
        multicolor: true
      }), TextAlign.configure({
        types: ['heading', 'paragraph'],
        alignments: ['left', 'center', 'right', 'justify']
      }), Subscript, Superscript, Link.configure({
        openOnClick: false
      }), Image.configure({
        inline: false
      }), Video, FontFamily, FontSize, Placeholder.configure({
        placeholder: props.placeholder
      }), Table.configure({
        resizable: true
      }), TableRow, TableCell, TableHeader, TaskList, TaskItem.configure({
        nested: true
      }), CodeBlockLowlight.configure({
        lowlight
      }), CharacterCount, Typography],
      onUpdate: ({
        editor: e
      }) => {
        const html = e.getHTML();
        emit('update:modelValue', html === '<p></p>' ? '' : html);
      }
    });

    // 字符统计
    const characterCount = computed(() => {
      if (!editor.value) return 0;
      return editor.value.storage.characterCount.characters();
    });
    const wordCount = computed(() => {
      if (!editor.value) return 0;
      return editor.value.storage.characterCount.words();
    });

    // 外部值同步
    watch(() => props.modelValue, val => {
      if (!editor.value) return;
      const current = editor.value.getHTML();
      const normalizedVal = val || '';
      const normalizedCurrent = current === '<p></p>' ? '' : current;
      if (normalizedVal !== normalizedCurrent) {
        editor.value.commands.setContent(val || '', false);
      }
    }, {
      flush: 'post'
    });

    // 当前状态（用于工具栏高亮）
    const currentHeading = computed(() => {
      if (!editor.value) return '0';
      for (let i = 1; i <= 6; i++) {
        if (editor.value.isActive('heading', {
          level: i
        })) return String(i);
      }
      return '0';
    });
    const currentFontFamily = computed(() => {
      if (!editor.value) return '';
      return editor.value.getAttributes('textStyle').fontFamily || '';
    });
    const currentFontSize = computed(() => {
      if (!editor.value) return '';
      return editor.value.getAttributes('textStyle').fontSize || '';
    });
    const currentColor = computed(() => {
      if (!editor.value) return '';
      return editor.value.getAttributes('textStyle').color || '';
    });
    const currentHighlight = computed(() => {
      if (!editor.value) return '';
      return editor.value.getAttributes('highlight').color || '';
    });

    // 工具栏操作
    const setHeading = level => {
      if (!editor.value) return;
      const lvl = parseInt(level);
      if (lvl === 0) {
        editor.value.chain().focus().setParagraph().run();
      } else {
        editor.value.chain().focus().toggleHeading({
          level: lvl
        }).run();
      }
    };
    const setFontFamily = font => {
      if (!editor.value) return;
      if (!font) {
        editor.value.chain().focus().unsetFontFamily().run();
      } else {
        editor.value.chain().focus().setFontFamily(font).run();
      }
    };
    const setFontSize = size => {
      if (!editor.value) return;
      if (!size) {
        editor.value.chain().focus().unsetFontSize().run();
      } else {
        editor.value.chain().focus().setFontSize(size).run();
      }
    };
    const handleIndent = () => {
      if (!editor.value) return;
      if (editor.value.isActive('listItem')) {
        editor.value.chain().focus().sinkListItem('listItem').run();
      }
    };
    const handleOutdent = () => {
      if (!editor.value) return;
      if (editor.value.isActive('listItem')) {
        editor.value.chain().focus().liftListItem('listItem').run();
      }
    };
    const toggleLink = () => {
      if (!editor.value) return;
      if (editor.value.isActive('link')) {
        editor.value.chain().focus().unsetLink().run();
        return;
      }
      const url = window.prompt('请输入链接地址', 'https://');
      if (url) {
        editor.value.chain().focus().extendMarkRange('link').setLink({
          href: url
        }).run();
      }
    };
    const triggerImageUpload = () => {
      imageInput.value?.click();
    };
    const triggerVideoUpload = () => {
      videoInput.value?.click();
    };
    const handleImageUpload = async event => {
      const file = event.target.files?.[0];
      if (!file) return;
      if (!file.type.startsWith('image/')) {
        ElMessage.warning('请选择图片文件');
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        ElMessage.warning('图片大小不能超过10MB');
        return;
      }
      try {
        const res = await uploadFile(file, props.uploadModule, 'public');
        const imageUrl = resolveUploadedFileUrl(res, process.env.VUE_APP_API_BASE_URL || '');
        if (!imageUrl) {
          ElMessage.error('上传失败，未获取到图片地址');
          return;
        }
        editor.value.chain().focus().setImage({
          src: imageUrl
        }).run();
      } catch (error) {
        ElMessage.error(error?.message || '图片上传失败');
      } finally {
        event.target.value = '';
      }
    };
    const handleVideoUpload = async event => {
      const file = event.target.files?.[0];
      if (!file) return;
      if (!file.type.startsWith('video/')) {
        ElMessage.warning('请选择视频文件');
        return;
      }
      if (file.size > 100 * 1024 * 1024) {
        ElMessage.warning('视频大小不能超过100MB');
        return;
      }
      try {
        const res = await uploadFile(file, props.uploadModule, 'public');
        const videoUrl = resolveUploadedFileUrl(res, process.env.VUE_APP_API_BASE_URL || '');
        if (!videoUrl) {
          ElMessage.error('上传失败，未获取到视频地址');
          return;
        }
        editor.value.chain().focus().setVideo({
          src: videoUrl
        }).run();
      } catch (error) {
        ElMessage.error(error?.message || '视频上传失败');
      } finally {
        event.target.value = '';
      }
    };
    const insertTable = () => {
      if (!editor.value) return;
      editor.value.chain().focus().insertTable({
        rows: 3,
        cols: 3,
        withHeaderRow: true
      }).run();
    };

    // 组件挂载后，等待编辑器 ready 再同步一次内容（处理 initForm 异步返回的情况）
    onMounted(async () => {
      if (!editor.value) return;
      await editor.value.ready;
      const val = props.modelValue || '';
      const current = editor.value.getHTML();
      const normalizedVal = val;
      const normalizedCurrent = current === '<p></p>' ? '' : current;
      if (normalizedVal !== normalizedCurrent) {
        editor.value.commands.setContent(val, false);
      }
    });
    onBeforeUnmount(() => {
      editor.value?.destroy();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(editor) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("select", {
        class: "toolbar-select",
        value: currentHeading.value,
        onChange: _cache[0] || (_cache[0] = $event => setHeading($event.target.value))
      }, [...(_cache[35] || (_cache[35] = [_createStaticVNode("<option value=\"0\" data-v-1398c07e>正文</option><option value=\"1\" data-v-1398c07e>标题 1</option><option value=\"2\" data-v-1398c07e>标题 2</option><option value=\"3\" data-v-1398c07e>标题 3</option><option value=\"4\" data-v-1398c07e>标题 4</option><option value=\"5\" data-v-1398c07e>标题 5</option><option value=\"6\" data-v-1398c07e>标题 6</option>", 7)]))], 40, _hoisted_3), _createElementVNode("select", {
        class: "toolbar-select",
        value: currentFontFamily.value,
        onChange: _cache[1] || (_cache[1] = $event => setFontFamily($event.target.value))
      }, [...(_cache[36] || (_cache[36] = [_createStaticVNode("<option value=\"\" data-v-1398c07e>默认字体</option><option value=\"Arial\" data-v-1398c07e>Arial</option><option value=\"Times New Roman\" data-v-1398c07e>Times New Roman</option><option value=\"Georgia\" data-v-1398c07e>Georgia</option><option value=\"Courier New\" data-v-1398c07e>Courier New</option><option value=\"Verdana\" data-v-1398c07e>Verdana</option><option value=\"Microsoft YaHei\" data-v-1398c07e>微软雅黑</option><option value=\"SimSun\" data-v-1398c07e>宋体</option><option value=\"SimHei\" data-v-1398c07e>黑体</option><option value=\"KaiTi\" data-v-1398c07e>楷体</option>", 10)]))], 40, _hoisted_4), _createElementVNode("select", {
        class: "toolbar-select",
        value: currentFontSize.value,
        onChange: _cache[2] || (_cache[2] = $event => setFontSize($event.target.value))
      }, [...(_cache[37] || (_cache[37] = [_createStaticVNode("<option value=\"\" data-v-1398c07e>默认</option><option value=\"12px\" data-v-1398c07e>12px</option><option value=\"14px\" data-v-1398c07e>14px</option><option value=\"16px\" data-v-1398c07e>16px</option><option value=\"18px\" data-v-1398c07e>18px</option><option value=\"20px\" data-v-1398c07e>20px</option><option value=\"24px\" data-v-1398c07e>24px</option><option value=\"28px\" data-v-1398c07e>28px</option><option value=\"32px\" data-v-1398c07e>32px</option><option value=\"36px\" data-v-1398c07e>36px</option>", 10)]))], 40, _hoisted_5), _cache[72] || (_cache[72] = _createElementVNode("div", {
        class: "toolbar-divider"
      }, null, -1)), _createElementVNode("button", {
        class: _normalizeClass(["toolbar-btn", {
          active: _unref(editor).isActive('bold')
        }]),
        onClick: _cache[3] || (_cache[3] = $event => _unref(editor).chain().focus().toggleBold().run()),
        title: "加粗"
      }, [...(_cache[38] || (_cache[38] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2.5"
      }, [_createElementVNode("path", {
        d: "M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
      }), _createElementVNode("path", {
        d: "M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
      })], -1)]))], 2), _createElementVNode("button", {
        class: _normalizeClass(["toolbar-btn", {
          active: _unref(editor).isActive('italic')
        }]),
        onClick: _cache[4] || (_cache[4] = $event => _unref(editor).chain().focus().toggleItalic().run()),
        title: "斜体"
      }, [...(_cache[39] || (_cache[39] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [_createElementVNode("line", {
        x1: "19",
        y1: "4",
        x2: "10",
        y2: "4"
      }), _createElementVNode("line", {
        x1: "14",
        y1: "20",
        x2: "5",
        y2: "20"
      }), _createElementVNode("line", {
        x1: "15",
        y1: "4",
        x2: "9",
        y2: "20"
      })], -1)]))], 2), _createElementVNode("button", {
        class: _normalizeClass(["toolbar-btn", {
          active: _unref(editor).isActive('underline')
        }]),
        onClick: _cache[5] || (_cache[5] = $event => _unref(editor).chain().focus().toggleUnderline().run()),
        title: "下划线"
      }, [...(_cache[40] || (_cache[40] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [_createElementVNode("path", {
        d: "M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"
      }), _createElementVNode("line", {
        x1: "4",
        y1: "21",
        x2: "20",
        y2: "21"
      })], -1)]))], 2), _createElementVNode("button", {
        class: _normalizeClass(["toolbar-btn", {
          active: _unref(editor).isActive('strike')
        }]),
        onClick: _cache[6] || (_cache[6] = $event => _unref(editor).chain().focus().toggleStrike().run()),
        title: "删除线"
      }, [...(_cache[41] || (_cache[41] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [_createElementVNode("line", {
        x1: "4",
        y1: "12",
        x2: "20",
        y2: "12"
      }), _createElementVNode("path", {
        d: "M17.5 7.5c0-2-1.5-3.5-5.5-3.5S6 5 6 7.5c0 4 12 3 12 8 0 2.5-2.5 4.5-6 4.5s-6-2-6-4.5"
      })], -1)]))], 2), _cache[73] || (_cache[73] = _createElementVNode("div", {
        class: "toolbar-divider"
      }, null, -1)), _createElementVNode("div", _hoisted_6, [_createElementVNode("button", _hoisted_7, [_cache[42] || (_cache[42] = _createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [_createElementVNode("path", {
        d: "M9.9 4.24A.5.5 0 0 1 10.5 4h3a.5.5 0 0 1 .47.33L18 16h-2l-1.3-4H9.3L8 16H6l3.9-11.76z",
        fill: "currentColor",
        stroke: "none"
      })], -1)), _createElementVNode("div", {
        class: "absolute bottom-0.5 left-1 right-1 h-1 rounded-sm",
        style: _normalizeStyle({
          backgroundColor: currentColor.value || '#000000'
        })
      }, null, 4)]), _createElementVNode("input", {
        type: "color",
        class: "absolute inset-0 opacity-0 cursor-pointer w-full h-full",
        value: currentColor.value || '#000000',
        onInput: _cache[7] || (_cache[7] = $event => _unref(editor).chain().focus().setColor($event.target.value).run()),
        title: "文字颜色"
      }, null, 40, _hoisted_8)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("button", _hoisted_10, [_cache[43] || (_cache[43] = _createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [_createElementVNode("path", {
        d: "M12 3l6 9H6l6-9z",
        fill: "currentColor",
        stroke: "none",
        opacity: "0.3"
      }), _createElementVNode("rect", {
        x: "3",
        y: "15",
        width: "18",
        height: "5",
        rx: "1",
        fill: "currentColor",
        stroke: "none",
        opacity: "0.5"
      })], -1)), _createElementVNode("div", {
        class: "absolute bottom-0.5 left-1 right-1 h-1 rounded-sm",
        style: _normalizeStyle({
          backgroundColor: currentHighlight.value || '#ffff00'
        })
      }, null, 4)]), _createElementVNode("input", {
        type: "color",
        class: "absolute inset-0 opacity-0 cursor-pointer w-full h-full",
        value: currentHighlight.value || '#ffff00',
        onInput: _cache[8] || (_cache[8] = $event => _unref(editor).chain().focus().toggleHighlight({
          color: $event.target.value
        }).run()),
        title: "背景颜色"
      }, null, 40, _hoisted_11)]), _cache[74] || (_cache[74] = _createElementVNode("div", {
        class: "toolbar-divider"
      }, null, -1)), _createElementVNode("button", {
        class: _normalizeClass(["toolbar-btn", {
          active: _unref(editor).isActive('superscript')
        }]),
        onClick: _cache[9] || (_cache[9] = $event => _unref(editor).chain().focus().toggleSuperscript().run()),
        title: "上标"
      }, [...(_cache[44] || (_cache[44] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "currentColor"
      }, [_createElementVNode("text", {
        x: "2",
        y: "18",
        "font-size": "14",
        "font-weight": "bold"
      }, "X"), _createElementVNode("text", {
        x: "14",
        y: "10",
        "font-size": "8",
        "font-weight": "bold"
      }, "2")], -1)]))], 2), _createElementVNode("button", {
        class: _normalizeClass(["toolbar-btn", {
          active: _unref(editor).isActive('subscript')
        }]),
        onClick: _cache[10] || (_cache[10] = $event => _unref(editor).chain().focus().toggleSubscript().run()),
        title: "下标"
      }, [...(_cache[45] || (_cache[45] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "currentColor"
      }, [_createElementVNode("text", {
        x: "2",
        y: "16",
        "font-size": "14",
        "font-weight": "bold"
      }, "X"), _createElementVNode("text", {
        x: "14",
        y: "20",
        "font-size": "8",
        "font-weight": "bold"
      }, "2")], -1)]))], 2), _cache[75] || (_cache[75] = _createElementVNode("div", {
        class: "toolbar-divider"
      }, null, -1)), _createElementVNode("button", {
        class: "toolbar-btn",
        onClick: handleOutdent,
        title: "减少缩进"
      }, [...(_cache[46] || (_cache[46] = [_createStaticVNode("<svg viewBox=\"0 0 24 24\" class=\"w-4 h-4\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1398c07e><line x1=\"3\" y1=\"4\" x2=\"21\" y2=\"4\" data-v-1398c07e></line><line x1=\"11\" y1=\"9\" x2=\"21\" y2=\"9\" data-v-1398c07e></line><line x1=\"11\" y1=\"14\" x2=\"21\" y2=\"14\" data-v-1398c07e></line><line x1=\"3\" y1=\"19\" x2=\"21\" y2=\"19\" data-v-1398c07e></line><polyline points=\"7 14 3 11.5 7 9\" data-v-1398c07e></polyline></svg>", 1)]))]), _createElementVNode("button", {
        class: "toolbar-btn",
        onClick: handleIndent,
        title: "增加缩进"
      }, [...(_cache[47] || (_cache[47] = [_createStaticVNode("<svg viewBox=\"0 0 24 24\" class=\"w-4 h-4\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1398c07e><line x1=\"3\" y1=\"4\" x2=\"21\" y2=\"4\" data-v-1398c07e></line><line x1=\"11\" y1=\"9\" x2=\"21\" y2=\"9\" data-v-1398c07e></line><line x1=\"11\" y1=\"14\" x2=\"21\" y2=\"14\" data-v-1398c07e></line><line x1=\"3\" y1=\"19\" x2=\"21\" y2=\"19\" data-v-1398c07e></line><polyline points=\"3 14 7 11.5 3 9\" data-v-1398c07e></polyline></svg>", 1)]))]), _cache[76] || (_cache[76] = _createElementVNode("div", {
        class: "toolbar-divider"
      }, null, -1)), _createElementVNode("button", {
        class: _normalizeClass(["toolbar-btn", {
          active: _unref(editor).isActive({
            textAlign: 'left'
          })
        }]),
        onClick: _cache[11] || (_cache[11] = $event => _unref(editor).chain().focus().setTextAlign('left').run()),
        title: "左对齐"
      }, [...(_cache[48] || (_cache[48] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [_createElementVNode("line", {
        x1: "3",
        y1: "6",
        x2: "21",
        y2: "6"
      }), _createElementVNode("line", {
        x1: "3",
        y1: "12",
        x2: "15",
        y2: "12"
      }), _createElementVNode("line", {
        x1: "3",
        y1: "18",
        x2: "18",
        y2: "18"
      })], -1)]))], 2), _createElementVNode("button", {
        class: _normalizeClass(["toolbar-btn", {
          active: _unref(editor).isActive({
            textAlign: 'center'
          })
        }]),
        onClick: _cache[12] || (_cache[12] = $event => _unref(editor).chain().focus().setTextAlign('center').run()),
        title: "居中"
      }, [...(_cache[49] || (_cache[49] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [_createElementVNode("line", {
        x1: "3",
        y1: "6",
        x2: "21",
        y2: "6"
      }), _createElementVNode("line", {
        x1: "6",
        y1: "12",
        x2: "18",
        y2: "12"
      }), _createElementVNode("line", {
        x1: "4",
        y1: "18",
        x2: "20",
        y2: "18"
      })], -1)]))], 2), _createElementVNode("button", {
        class: _normalizeClass(["toolbar-btn", {
          active: _unref(editor).isActive({
            textAlign: 'right'
          })
        }]),
        onClick: _cache[13] || (_cache[13] = $event => _unref(editor).chain().focus().setTextAlign('right').run()),
        title: "右对齐"
      }, [...(_cache[50] || (_cache[50] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [_createElementVNode("line", {
        x1: "3",
        y1: "6",
        x2: "21",
        y2: "6"
      }), _createElementVNode("line", {
        x1: "9",
        y1: "12",
        x2: "21",
        y2: "12"
      }), _createElementVNode("line", {
        x1: "6",
        y1: "18",
        x2: "21",
        y2: "18"
      })], -1)]))], 2), _createElementVNode("button", {
        class: _normalizeClass(["toolbar-btn", {
          active: _unref(editor).isActive({
            textAlign: 'justify'
          })
        }]),
        onClick: _cache[14] || (_cache[14] = $event => _unref(editor).chain().focus().setTextAlign('justify').run()),
        title: "两端对齐"
      }, [...(_cache[51] || (_cache[51] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [_createElementVNode("line", {
        x1: "3",
        y1: "6",
        x2: "21",
        y2: "6"
      }), _createElementVNode("line", {
        x1: "3",
        y1: "12",
        x2: "21",
        y2: "12"
      }), _createElementVNode("line", {
        x1: "3",
        y1: "18",
        x2: "21",
        y2: "18"
      })], -1)]))], 2), _cache[77] || (_cache[77] = _createElementVNode("div", {
        class: "toolbar-divider"
      }, null, -1)), _createElementVNode("button", {
        class: _normalizeClass(["toolbar-btn", {
          active: _unref(editor).isActive('orderedList')
        }]),
        onClick: _cache[15] || (_cache[15] = $event => _unref(editor).chain().focus().toggleOrderedList().run()),
        title: "有序列表"
      }, [...(_cache[52] || (_cache[52] = [_createStaticVNode("<svg viewBox=\"0 0 24 24\" class=\"w-4 h-4\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1398c07e><line x1=\"10\" y1=\"6\" x2=\"21\" y2=\"6\" data-v-1398c07e></line><line x1=\"10\" y1=\"12\" x2=\"21\" y2=\"12\" data-v-1398c07e></line><line x1=\"10\" y1=\"18\" x2=\"21\" y2=\"18\" data-v-1398c07e></line><text x=\"2\" y=\"8\" font-size=\"7\" fill=\"currentColor\" stroke=\"none\" font-weight=\"bold\" data-v-1398c07e>1</text><text x=\"2\" y=\"14\" font-size=\"7\" fill=\"currentColor\" stroke=\"none\" font-weight=\"bold\" data-v-1398c07e>2</text><text x=\"2\" y=\"20\" font-size=\"7\" fill=\"currentColor\" stroke=\"none\" font-weight=\"bold\" data-v-1398c07e>3</text></svg>", 1)]))], 2), _createElementVNode("button", {
        class: _normalizeClass(["toolbar-btn", {
          active: _unref(editor).isActive('bulletList')
        }]),
        onClick: _cache[16] || (_cache[16] = $event => _unref(editor).chain().focus().toggleBulletList().run()),
        title: "无序列表"
      }, [...(_cache[53] || (_cache[53] = [_createStaticVNode("<svg viewBox=\"0 0 24 24\" class=\"w-4 h-4\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1398c07e><line x1=\"9\" y1=\"6\" x2=\"20\" y2=\"6\" data-v-1398c07e></line><line x1=\"9\" y1=\"12\" x2=\"20\" y2=\"12\" data-v-1398c07e></line><line x1=\"9\" y1=\"18\" x2=\"20\" y2=\"18\" data-v-1398c07e></line><circle cx=\"4.5\" cy=\"6\" r=\"1.5\" fill=\"currentColor\" stroke=\"none\" data-v-1398c07e></circle><circle cx=\"4.5\" cy=\"12\" r=\"1.5\" fill=\"currentColor\" stroke=\"none\" data-v-1398c07e></circle><circle cx=\"4.5\" cy=\"18\" r=\"1.5\" fill=\"currentColor\" stroke=\"none\" data-v-1398c07e></circle></svg>", 1)]))], 2), _createElementVNode("button", {
        class: _normalizeClass(["toolbar-btn", {
          active: _unref(editor).isActive('taskList')
        }]),
        onClick: _cache[17] || (_cache[17] = $event => _unref(editor).chain().focus().toggleTaskList().run()),
        title: "任务列表"
      }, [...(_cache[54] || (_cache[54] = [_createStaticVNode("<svg viewBox=\"0 0 24 24\" class=\"w-4 h-4\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1398c07e><rect x=\"3\" y=\"5\" width=\"6\" height=\"6\" rx=\"1\" data-v-1398c07e></rect><polyline points=\"5 8 6 9 9 6\" stroke-width=\"1.5\" data-v-1398c07e></polyline><line x1=\"13\" y1=\"8\" x2=\"21\" y2=\"8\" data-v-1398c07e></line><rect x=\"3\" y=\"14\" width=\"6\" height=\"6\" rx=\"1\" data-v-1398c07e></rect><line x1=\"13\" y1=\"17\" x2=\"21\" y2=\"17\" data-v-1398c07e></line></svg>", 1)]))], 2), _cache[78] || (_cache[78] = _createElementVNode("div", {
        class: "toolbar-divider"
      }, null, -1)), _createElementVNode("button", {
        class: _normalizeClass(["toolbar-btn", {
          active: _unref(editor).isActive('blockquote')
        }]),
        onClick: _cache[18] || (_cache[18] = $event => _unref(editor).chain().focus().toggleBlockquote().run()),
        title: "引用"
      }, [...(_cache[55] || (_cache[55] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "currentColor"
      }, [_createElementVNode("path", {
        d: "M10 8.5c0 1.93-1.57 3.5-3.5 3.5H6v1c0 1.66 1.34 3 3 3v2c-2.76 0-5-2.24-5-5V7h4.5C9.33 7 10 7.67 10 8.5zm8 0c0 1.93-1.57 3.5-3.5 3.5H14v1c0 1.66 1.34 3 3 3v2c-2.76 0-5-2.24-5-5V7h4.5c.83 0 1.5.67 1.5 1.5z"
      })], -1)]))], 2), _createElementVNode("button", {
        class: _normalizeClass(["toolbar-btn", {
          active: _unref(editor).isActive('codeBlock')
        }]),
        onClick: _cache[19] || (_cache[19] = $event => _unref(editor).chain().focus().toggleCodeBlock().run()),
        title: "代码块"
      }, [...(_cache[56] || (_cache[56] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [_createElementVNode("polyline", {
        points: "16 18 22 12 16 6"
      }), _createElementVNode("polyline", {
        points: "8 6 2 12 8 18"
      })], -1)]))], 2), _createElementVNode("button", {
        class: "toolbar-btn",
        onClick: _cache[20] || (_cache[20] = $event => _unref(editor).chain().focus().setHorizontalRule().run()),
        title: "分隔线"
      }, [...(_cache[57] || (_cache[57] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [_createElementVNode("line", {
        x1: "3",
        y1: "12",
        x2: "21",
        y2: "12"
      })], -1)]))]), _cache[79] || (_cache[79] = _createElementVNode("div", {
        class: "toolbar-divider"
      }, null, -1)), _createElementVNode("button", {
        class: "toolbar-btn",
        onClick: insertTable,
        title: "插入表格"
      }, [...(_cache[58] || (_cache[58] = [_createStaticVNode("<svg viewBox=\"0 0 24 24\" class=\"w-4 h-4\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1398c07e><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" data-v-1398c07e></rect><line x1=\"3\" y1=\"9\" x2=\"21\" y2=\"9\" data-v-1398c07e></line><line x1=\"3\" y1=\"15\" x2=\"21\" y2=\"15\" data-v-1398c07e></line><line x1=\"9\" y1=\"3\" x2=\"9\" y2=\"21\" data-v-1398c07e></line><line x1=\"15\" y1=\"3\" x2=\"15\" y2=\"21\" data-v-1398c07e></line></svg>", 1)]))]), _unref(editor).isActive('table') ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("button", {
        class: "toolbar-btn",
        onClick: _cache[21] || (_cache[21] = $event => _unref(editor).chain().focus().addColumnAfter().run()),
        title: "右侧添加列"
      }, [...(_cache[59] || (_cache[59] = [_createStaticVNode("<svg viewBox=\"0 0 24 24\" class=\"w-3.5 h-3.5\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1398c07e><rect x=\"3\" y=\"3\" width=\"12\" height=\"18\" rx=\"1\" data-v-1398c07e></rect><line x1=\"9\" y1=\"3\" x2=\"9\" y2=\"21\" data-v-1398c07e></line><line x1=\"19\" y1=\"8\" x2=\"19\" y2=\"16\" data-v-1398c07e></line><line x1=\"15\" y1=\"12\" x2=\"23\" y2=\"12\" data-v-1398c07e></line></svg>", 1)]))]), _createElementVNode("button", {
        class: "toolbar-btn",
        onClick: _cache[22] || (_cache[22] = $event => _unref(editor).chain().focus().addRowAfter().run()),
        title: "下方添加行"
      }, [...(_cache[60] || (_cache[60] = [_createStaticVNode("<svg viewBox=\"0 0 24 24\" class=\"w-3.5 h-3.5\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1398c07e><rect x=\"3\" y=\"3\" width=\"18\" height=\"12\" rx=\"1\" data-v-1398c07e></rect><line x1=\"3\" y1=\"9\" x2=\"21\" y2=\"9\" data-v-1398c07e></line><line x1=\"8\" y1=\"19\" x2=\"16\" y2=\"19\" data-v-1398c07e></line><line x1=\"12\" y1=\"15\" x2=\"12\" y2=\"23\" data-v-1398c07e></line></svg>", 1)]))]), _createElementVNode("button", {
        class: "toolbar-btn",
        onClick: _cache[23] || (_cache[23] = $event => _unref(editor).chain().focus().mergeCells().run()),
        title: "合并单元格"
      }, [...(_cache[61] || (_cache[61] = [_createStaticVNode("<svg viewBox=\"0 0 24 24\" class=\"w-3.5 h-3.5\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1398c07e><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" data-v-1398c07e></rect><line x1=\"3\" y1=\"12\" x2=\"21\" y2=\"12\" data-v-1398c07e></line><line x1=\"12\" y1=\"3\" x2=\"12\" y2=\"12\" data-v-1398c07e></line><polyline points=\"8 7 12 5 16 7\" stroke-width=\"1.5\" data-v-1398c07e></polyline></svg>", 1)]))]), _createElementVNode("button", {
        class: "toolbar-btn",
        onClick: _cache[24] || (_cache[24] = $event => _unref(editor).chain().focus().splitCell().run()),
        title: "拆分单元格"
      }, [...(_cache[62] || (_cache[62] = [_createStaticVNode("<svg viewBox=\"0 0 24 24\" class=\"w-3.5 h-3.5\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1398c07e><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" data-v-1398c07e></rect><line x1=\"3\" y1=\"12\" x2=\"21\" y2=\"12\" data-v-1398c07e></line><line x1=\"12\" y1=\"3\" x2=\"12\" y2=\"21\" data-v-1398c07e></line><polyline points=\"8 10 12 12 16 10\" stroke-width=\"1.5\" data-v-1398c07e></polyline></svg>", 1)]))]), _createElementVNode("button", {
        class: "toolbar-btn text-red-500 hover:text-red-600",
        onClick: _cache[25] || (_cache[25] = $event => _unref(editor).chain().focus().deleteColumn().run()),
        title: "删除列"
      }, [...(_cache[63] || (_cache[63] = [_createStaticVNode("<svg viewBox=\"0 0 24 24\" class=\"w-3.5 h-3.5\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1398c07e><rect x=\"6\" y=\"3\" width=\"12\" height=\"18\" rx=\"1\" data-v-1398c07e></rect><line x1=\"6\" y1=\"9\" x2=\"18\" y2=\"9\" data-v-1398c07e></line><line x1=\"6\" y1=\"15\" x2=\"18\" y2=\"15\" data-v-1398c07e></line><line x1=\"2\" y1=\"12\" x2=\"4\" y2=\"12\" data-v-1398c07e></line><line x1=\"20\" y1=\"12\" x2=\"22\" y2=\"12\" data-v-1398c07e></line></svg>", 1)]))]), _createElementVNode("button", {
        class: "toolbar-btn text-red-500 hover:text-red-600",
        onClick: _cache[26] || (_cache[26] = $event => _unref(editor).chain().focus().deleteRow().run()),
        title: "删除行"
      }, [...(_cache[64] || (_cache[64] = [_createStaticVNode("<svg viewBox=\"0 0 24 24\" class=\"w-3.5 h-3.5\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1398c07e><rect x=\"3\" y=\"6\" width=\"18\" height=\"12\" rx=\"1\" data-v-1398c07e></rect><line x1=\"9\" y1=\"6\" x2=\"9\" y2=\"18\" data-v-1398c07e></line><line x1=\"15\" y1=\"6\" x2=\"15\" y2=\"18\" data-v-1398c07e></line><line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"4\" data-v-1398c07e></line><line x1=\"12\" y1=\"20\" x2=\"12\" y2=\"22\" data-v-1398c07e></line></svg>", 1)]))]), _createElementVNode("button", {
        class: "toolbar-btn text-red-500 hover:text-red-600",
        onClick: _cache[27] || (_cache[27] = $event => _unref(editor).chain().focus().deleteTable().run()),
        title: "删除表格"
      }, [...(_cache[65] || (_cache[65] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-3.5 h-3.5",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [_createElementVNode("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "2"
      }), _createElementVNode("line", {
        x1: "9",
        y1: "9",
        x2: "15",
        y2: "15"
      }), _createElementVNode("line", {
        x1: "15",
        y1: "9",
        x2: "9",
        y2: "15"
      })], -1)]))])], 64)) : _createCommentVNode("", true), _cache[80] || (_cache[80] = _createElementVNode("div", {
        class: "toolbar-divider"
      }, null, -1)), _createElementVNode("button", {
        class: _normalizeClass(["toolbar-btn", {
          active: _unref(editor).isActive('link')
        }]),
        onClick: toggleLink,
        title: "链接"
      }, [...(_cache[66] || (_cache[66] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [_createElementVNode("path", {
        d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
      }), _createElementVNode("path", {
        d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
      })], -1)]))], 2), _createElementVNode("button", {
        class: "toolbar-btn",
        onClick: triggerImageUpload,
        title: "图片"
      }, [...(_cache[67] || (_cache[67] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [_createElementVNode("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "2"
      }), _createElementVNode("circle", {
        cx: "8.5",
        cy: "8.5",
        r: "1.5"
      }), _createElementVNode("path", {
        d: "M21 15l-5-5L5 21"
      })], -1)]))]), _createElementVNode("button", {
        class: "toolbar-btn",
        onClick: triggerVideoUpload,
        title: "视频"
      }, [...(_cache[68] || (_cache[68] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [_createElementVNode("rect", {
        x: "2",
        y: "4",
        width: "20",
        height: "16",
        rx: "2"
      }), _createElementVNode("polygon", {
        points: "10 8 16 12 10 16",
        fill: "currentColor",
        stroke: "none"
      })], -1)]))]), _cache[81] || (_cache[81] = _createElementVNode("div", {
        class: "toolbar-divider"
      }, null, -1)), _createElementVNode("button", {
        class: "toolbar-btn",
        disabled: !_unref(editor).can().undo(),
        onClick: _cache[28] || (_cache[28] = $event => _unref(editor).chain().focus().undo().run()),
        title: "撤销"
      }, [...(_cache[69] || (_cache[69] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [_createElementVNode("polyline", {
        points: "1 4 1 10 7 10"
      }), _createElementVNode("path", {
        d: "M3.51 15a9 9 0 1 0 2.13-9.36L1 10"
      })], -1)]))], 8, _hoisted_12), _createElementVNode("button", {
        class: "toolbar-btn",
        disabled: !_unref(editor).can().redo(),
        onClick: _cache[29] || (_cache[29] = $event => _unref(editor).chain().focus().redo().run()),
        title: "重做"
      }, [...(_cache[70] || (_cache[70] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [_createElementVNode("polyline", {
        points: "23 4 23 10 17 10"
      }), _createElementVNode("path", {
        d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10"
      })], -1)]))], 8, _hoisted_13), _cache[82] || (_cache[82] = _createElementVNode("div", {
        class: "toolbar-divider"
      }, null, -1)), _createElementVNode("button", {
        class: "toolbar-btn",
        onClick: _cache[30] || (_cache[30] = $event => _unref(editor).chain().focus().clearNodes().unsetAllMarks().run()),
        title: "清除格式"
      }, [...(_cache[71] || (_cache[71] = [_createStaticVNode("<svg viewBox=\"0 0 24 24\" class=\"w-4 h-4\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-1398c07e><path d=\"M4 7h16\" data-v-1398c07e></path><path d=\"M10 4l-2 16\" data-v-1398c07e></path><path d=\"M17 17l4 4\" data-v-1398c07e></path><path d=\"M21 17l-4 4\" data-v-1398c07e></path></svg>", 1)]))])])) : _createCommentVNode("", true), _unref(editor) ? (_openBlock(), _createBlock(_unref(BubbleMenu), {
        key: 1,
        editor: _unref(editor),
        "tippy-options": {
          duration: 150
        },
        class: "bubble-menu flex items-center gap-0.5 rounded-lg border border-slate-200 bg-white px-1 py-1 shadow-lg"
      }, {
        default: _withCtx(() => [_createElementVNode("button", {
          class: _normalizeClass(["toolbar-btn", {
            active: _unref(editor).isActive('bold')
          }]),
          onClick: _cache[31] || (_cache[31] = $event => _unref(editor).chain().focus().toggleBold().run()),
          title: "加粗"
        }, [...(_cache[83] || (_cache[83] = [_createElementVNode("svg", {
          viewBox: "0 0 24 24",
          class: "w-3.5 h-3.5",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2.5"
        }, [_createElementVNode("path", {
          d: "M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
        }), _createElementVNode("path", {
          d: "M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
        })], -1)]))], 2), _createElementVNode("button", {
          class: _normalizeClass(["toolbar-btn", {
            active: _unref(editor).isActive('italic')
          }]),
          onClick: _cache[32] || (_cache[32] = $event => _unref(editor).chain().focus().toggleItalic().run()),
          title: "斜体"
        }, [...(_cache[84] || (_cache[84] = [_createElementVNode("svg", {
          viewBox: "0 0 24 24",
          class: "w-3.5 h-3.5",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2"
        }, [_createElementVNode("line", {
          x1: "19",
          y1: "4",
          x2: "10",
          y2: "4"
        }), _createElementVNode("line", {
          x1: "14",
          y1: "20",
          x2: "5",
          y2: "20"
        }), _createElementVNode("line", {
          x1: "15",
          y1: "4",
          x2: "9",
          y2: "20"
        })], -1)]))], 2), _createElementVNode("button", {
          class: _normalizeClass(["toolbar-btn", {
            active: _unref(editor).isActive('underline')
          }]),
          onClick: _cache[33] || (_cache[33] = $event => _unref(editor).chain().focus().toggleUnderline().run()),
          title: "下划线"
        }, [...(_cache[85] || (_cache[85] = [_createElementVNode("svg", {
          viewBox: "0 0 24 24",
          class: "w-3.5 h-3.5",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2"
        }, [_createElementVNode("path", {
          d: "M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"
        }), _createElementVNode("line", {
          x1: "4",
          y1: "21",
          x2: "20",
          y2: "21"
        })], -1)]))], 2), _createElementVNode("button", {
          class: _normalizeClass(["toolbar-btn", {
            active: _unref(editor).isActive('strike')
          }]),
          onClick: _cache[34] || (_cache[34] = $event => _unref(editor).chain().focus().toggleStrike().run()),
          title: "删除线"
        }, [...(_cache[86] || (_cache[86] = [_createElementVNode("svg", {
          viewBox: "0 0 24 24",
          class: "w-3.5 h-3.5",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2"
        }, [_createElementVNode("line", {
          x1: "4",
          y1: "12",
          x2: "20",
          y2: "12"
        }), _createElementVNode("path", {
          d: "M17.5 7.5c0-2-1.5-3.5-5.5-3.5S6 5 6 7.5c0 4 12 3 12 8 0 2.5-2.5 4.5-6 4.5s-6-2-6-4.5"
        })], -1)]))], 2), _cache[88] || (_cache[88] = _createElementVNode("div", {
          class: "mx-0.5 h-4 w-px bg-slate-200"
        }, null, -1)), _createElementVNode("button", {
          class: _normalizeClass(["toolbar-btn", {
            active: _unref(editor).isActive('link')
          }]),
          onClick: toggleLink,
          title: "链接"
        }, [...(_cache[87] || (_cache[87] = [_createElementVNode("svg", {
          viewBox: "0 0 24 24",
          class: "w-3.5 h-3.5",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2"
        }, [_createElementVNode("path", {
          d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
        }), _createElementVNode("path", {
          d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
        })], -1)]))], 2)]),
        _: 1
      }, 8, ["editor"])) : _createCommentVNode("", true), _createVNode(_unref(EditorContent), {
        editor: _unref(editor)
      }, null, 8, ["editor"]), _unref(editor) ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("span", null, _toDisplayString(characterCount.value) + " 字符", 1), _createElementVNode("span", null, _toDisplayString(wordCount.value) + " 字", 1)])) : _createCommentVNode("", true), _createElementVNode("input", {
        ref_key: "imageInput",
        ref: imageInput,
        type: "file",
        accept: "image/*",
        class: "hidden",
        onChange: handleImageUpload
      }, null, 544), _createElementVNode("input", {
        ref_key: "videoInput",
        ref: videoInput,
        type: "file",
        accept: "video/*",
        class: "hidden",
        onChange: handleVideoUpload
      }, null, 544)]);
    };
  }
};